import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=5f1b9c96"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=5f1b9c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports